module.exports = __webpack_public_path__ + "img/MU.da8beb36.svg";